import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messages", "firstUnread", "form"]

  connect() {
    console.log('connected to chat controller')
    const spinnerElement = document.querySelector("[data-controller~='spinner']")
    if (spinnerElement) {
      this.spinnerController = this.application.getControllerForElementAndIdentifier(spinnerElement, "spinner")
    }
    this.scrollToFirstUnread()
  }

  submit(event) {
    event.preventDefault()

    const form = this.formTarget
    const formData = new FormData(form)

    fetch(form.action, {
      method: "POST",
      headers: {
        "Accept": "application/json"
      },
      body: formData
    })
      .then(r => r.json())
      .then(data => {
        this.messagesTarget.insertAdjacentHTML("beforeend", data.html)
        this.scrollToBottom()
        form.reset()
        form.querySelector("[type='submit']").disabled = false
        this.spinnerController?.hide();
      })

  }

  scrollToFirstUnread() {
    if (this.hasFirstUnreadTarget) {
      this.firstUnreadTarget.scrollIntoView({
        behavior: "smooth",
        block: "start"
      })
    } else {
      this.scrollToBottom();
    }
  }

  scrollToBottom() {
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
  }
}
